import { render, staticRenderFns } from "./ManutencaoLavadorPrincipal.vue?vue&type=template&id=2eadfa9f&"
import script from "./ManutencaoLavadorPrincipal.vue?vue&type=script&lang=js&"
export * from "./ManutencaoLavadorPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports